export default {
    SET_METHOD(state, method) {
        state.method = method
    },
	SET_ACTIVE(state, active) {
        state.active  = active !== null
        state.section = active
    },
    SET_AUTHENTICATED(state, authenticated) {
        state.authenticated = authenticated
    },
    SET_RESPONSE(state, response) {
        state.response = response == null ? {title:null, description:null, class:null} : response
    }
}
